export const HeroParallax = {
	init() {
		const hero = document.querySelector(
			'#main-content > .block-hero, #main-content > .block-resident-life-hero, #main-content > .block-help-hero, #main-content > .block-about-hero'
		);
		if ( ! hero ) return;

		this.wrapContent( hero );

		hero.style.position = 'sticky';
		hero.style.top = '-150px';
		hero.style.zIndex = '1';
	},

	wrapContent( hero ) {
		const main = hero.parentElement;
		const siblings = [];
		let el = hero.nextElementSibling;
		while ( el ) {
			siblings.push( el );
			el = el.nextElementSibling;
		}
		if ( ! siblings.length ) return;

		const wrap = document.createElement( 'div' );
		wrap.className = 'content-wrap';
		siblings.forEach( ( s ) => wrap.appendChild( s ) );
		main.appendChild( wrap );
	},
};
